import React from 'react';
import StyledNavbar from './Nav.styled';
import { ComponentProps, GroupComponent } from './Nav.types';
import Context from './Context';
import NavLinksContainer from './NavLinksContainer/NavLinksContainer';
import NavDivider from './NavDivider/NavDivider';
import NavLink from './NavLink/NavLink';
import NavContainer from './NavContainer/NavContainer';

const Nav: React.FC<ComponentProps> & GroupComponent = ({ children, variant = 'dark', ...props }) => {
  return (
    <Context.Provider
      value={{
        variant,
      }}>
      <StyledNavbar variant={variant} {...props}>
        {children}
      </StyledNavbar>
    </Context.Provider>
  );
};

Nav.Links = NavLinksContainer;
Nav.Link = NavLink;
Nav.Divider = NavDivider;
Nav.Container = NavContainer;

export default Nav;
